import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JournalService } from '../journal.service';
import { GetContentManagementDataService } from '../../services/get-content-management-data.service';

@Injectable({
  providedIn: 'root'
})
export class DataResolver implements Resolve<any> {
  constructor(private journalService: JournalService, private contentService: GetContentManagementDataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const journalId = route.paramMap.get('journal_id');
    const pageNameId = route.paramMap.get('page_name_id');
    const token = route.paramMap.get('token');
    const languageCode = route.paramMap.get('languageCode');

    if (journalId && pageNameId && token && languageCode) {
      return this.contentService.getCurrentContentData({ journal_id: journalId, page_name_id: pageNameId, token, languageCode }).pipe(
        catchError(error => {
          console.error('Error fetching content:', error);
          // Handle the error gracefully, for example:
          // return of(null); // return an observable emitting null
          // or return an observable emitting an empty object/array, depending on your use case
          return of({});
        })
      );
    } else {
      // If any required parameter is missing, return an empty observable
      return of({});
    }
  }
}
